import { Component, OnInit } from '@angular/core';
import { SalesOrderTableCustomComponentDirective } from './sales-order-table-custom.component';

@Component({
  selector: 'sales-ui-order-tags-cell',
  template: `
    <div class="tags">
      <div class="tag" *ngFor="let tag of tags">
        <glxy-badge color="grey">{{ tag }}</glxy-badge>
      </div>
    </div>
  `,
  styles: [
    `
      .tags {
        display: flex;
      }
      .tag {
        margin: 2px;
      }
    `,
  ],
})
export class OrderTagsCellComponent extends SalesOrderTableCustomComponentDirective implements OnInit {
  tags: string[];

  ngOnInit(): void {
    this.tags = this.element.tags || [];
  }
}
